import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDocuments } from "./viewDocuments.thunks";

interface ViewDocumentsState {
	documents: any[];
	selectedDocId: number | null;
	fileName: string;
}

const initialState: ViewDocumentsState = {
	documents: [],
	selectedDocId: null,
	fileName: "",
};

const viewDocumentsSlice = createSlice({
	name: "viewDocumentsSlice",
	initialState,
	reducers: {
		setSelectedDocId: (state, action: PayloadAction<number | null>) => {
			state.selectedDocId = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getDocuments.fulfilled, (state, action: PayloadAction<any[]>) => {
			state.documents = action.payload;
			console.log(action.payload);
		});
	},
});

export const { setSelectedDocId } = viewDocumentsSlice.actions;
export default viewDocumentsSlice.reducer;
